import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import VdaySvg from './VdaySvg';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    root: {
      width: '100%',
      height: 310,
      backgroundImage: theme.displayGif(
        'url("https://media.giphy.com/media/11fIOE3vkIPdIY/giphy.gif")'
      ),
      borderRadius: theme.spacing(0.5),
      display: 'flex',
      justifyContent: 'center',
    },
    img: {
      width: '95%',
      height: 'auto',
    },
  })
);

export const ValentinesDayPromotion = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <VdaySvg className={classes.img} />
    </div>
  );
};

export default ValentinesDayPromotion;
